import http from '../../utils/http';
const rootUrl = '/api';
const dentalxUrl = '/dentalx/api';

const order = {
	/**
	 * 订单列表
	 * @returns
	 */
	listCloudOrder(params) {
		return http.get( `${dentalxUrl}/dentalxListCloudOrder`, params, { errCode: '@shining3d/xl-design-order.apiErr.order' });
	},
	/**
	 * 更新用户同意的合规版本
	 * @returns
	 */
	updateComplianceVersion(data) {
		return http.post( `${dentalxUrl}/dentalxUpdateComplianceVersion`, data, { errCode: '@shining3d/xl-design-order.apiErr.order' });
	},
    /**
	 * 设计单调整
	 * @returns
	 */
	adjustOrderDesign(data) {
		return http.post( `${dentalxUrl}/dentalxAdjustOrderDesign`, data, { errCode: 'adjustOrderDesign' });
	},
	 /**
	 * 取消设计单
	 * @returns
	 */
	 changeCloudOrderState(data) {
		return http.post( `${dentalxUrl}/dentalxChangeCloudOrderState`, data, { errCode: 'changeCloudOrderState' });
	},
	/**
	 * 设计单申请售后
	 * @returns
	 */
	applyRedesignOrder(data) {
		return http.post( `${dentalxUrl}/dentalxApplyRedesignOrder`, data, { errCode: 'applyRedesignOrder' });
	},
	/**
	 * 确认支付获取积分信息及支付信息
	 * @returns
	 */
	createShiningPay(data) {
		return http.post( `${rootUrl}/createShiningPay`, data, { errCode: '@shining3d/xl-design-order.apiErr.order' });
	},
	/**
	 * 积分支付付款
	 * @returns
	 */
	shiningPay(data) {
		return http.post( `${rootUrl}/shiningPay`, data, { errCode: '@shining3d/xl-design-order.apiErr.order' });
	},
	/**
	 * 机构切换
	*/
	postOrgChange( params ) {
		return http.get( `${rootUrl}/dentalUserFactoryChange`, params, { errCode: 'postOrgChange' });
	},
	/**
	 *  服务平台确认设计师提交的设计文件
	 * @returns
	 */
	dentalxConfirmTransferOrderDesign(data) {
		return http.post( `${rootUrl}/dentalxConfirmTransferOrderDesign`, data, { errCode: 'order' });
	}
	,
	/**
	 *  服务平台打回设计师提交的设计文件
	 * @returns
	 */
	dentalxRejectTransferOrderDesign(data) {
		return http.post( `${rootUrl}/dentalxRejectTransferOrderDesign`, data, { errCode: '@shining3d/xl-design-order.apiErr.order' });
	},
	/**
	 * 获取设计文件下载密钥
	*/
	dentalxGenerateDesignSecret(data){
		return http.post( `${dentalxUrl}/dentalxGenerateDesignSecret`, data, { errCode: '' });
	}
};
export default order;
